"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DELETE_ACTIVITY = void 0;
var DELETE_ACTIVITY = 'DIRECT_LINE/DELETE_ACTIVITY';
exports.DELETE_ACTIVITY = DELETE_ACTIVITY;

function deleteActivity(activityID) {
  return {
    type: DELETE_ACTIVITY,
    payload: {
      activityID: activityID
    }
  };
}

var _default = deleteActivity;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUxFVEVfQUNUSVZJVFkiLCJkZWxldGVBY3Rpdml0eSIsImFjdGl2aXR5SUQiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2RlbGV0ZUFjdGl2aXR5LnRzIl0sInNvdXJjZXNDb250ZW50IjpbInR5cGUgRGVsZXRlQWN0aXZpdHlBY3Rpb25UeXBlID0gJ0RJUkVDVF9MSU5FL0RFTEVURV9BQ1RJVklUWSc7XG5cbnR5cGUgRGVsZXRlQWN0aXZpdHlBY3Rpb24gPSB7XG4gIHBheWxvYWQ6IHsgYWN0aXZpdHlJRDogc3RyaW5nIH07XG4gIHR5cGU6IERlbGV0ZUFjdGl2aXR5QWN0aW9uVHlwZTtcbn07XG5cbmNvbnN0IERFTEVURV9BQ1RJVklUWTogRGVsZXRlQWN0aXZpdHlBY3Rpb25UeXBlID0gJ0RJUkVDVF9MSU5FL0RFTEVURV9BQ1RJVklUWSc7XG5cbmZ1bmN0aW9uIGRlbGV0ZUFjdGl2aXR5KGFjdGl2aXR5SUQ6IHN0cmluZyk6IERlbGV0ZUFjdGl2aXR5QWN0aW9uIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBERUxFVEVfQUNUSVZJVFksXG4gICAgcGF5bG9hZDogeyBhY3Rpdml0eUlEIH1cbiAgfTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZGVsZXRlQWN0aXZpdHk7XG5leHBvcnQgeyBERUxFVEVfQUNUSVZJVFkgfTtcbmV4cG9ydCB0eXBlIHsgRGVsZXRlQWN0aXZpdHlBY3Rpb24gfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBT0EsSUFBTUEsZUFBeUMsR0FBRyw2QkFBbEQ7OztBQUVBLFNBQVNDLGNBQVQsQ0FBd0JDLFVBQXhCLEVBQWtFO0VBQ2hFLE9BQU87SUFDTEMsSUFBSSxFQUFFSCxlQUREO0lBRUxJLE9BQU8sRUFBRTtNQUFFRixVQUFVLEVBQVZBO0lBQUY7RUFGSixDQUFQO0FBSUQ7O2VBRWNELGMifQ==